import { Button, Column, Icon, Input, Row, Text } from "@amzn/meridian";
import React, { useState } from "react";
import ImageUploader from "./imageUploader";
import SampleImageCard from "./sampleImageCard";
import closeKnockoutTokens from "@amzn/meridian-tokens/base/icon/close-knockout";
import { Example, Question } from "src/data/types";
type AddQuestionFormCardProps = {
  form: Question;
  deleteForm: (id: string) => void;
  handleQuestionFormChange: (
    id: string,
    key: keyof Question,
    value: string
  ) => void;
};
const AddQuestionFormCard = ({
  form,
  deleteForm,
  handleQuestionFormChange,
}: AddQuestionFormCardProps) => {
  const [upladedImage, setUploadedImage] = useState<File | null>(null);

  const handleImageUpload = (image: File) => {
    const url = URL.createObjectURL(image);
    const example: Example = {
      exampleId: String(Math.random()),
      imageURL: url,
      exampleType: "POSITIVE_EXAMPLE",
      expectedResult: "YES",
    };
    //dispatch to UPDATE images for the current question here
  };
  return (
    <Column
      spacingInset={"500"}
      minWidth={700}
      minHeight={538}
      type="outline"
      spacing={"500"}
      className="add-question-form-card"
    >
      <Column>
        <Row widths={"fill"}>
          <Input
            value={form.questionText}
            size="xlarge"
            label="Question"
            onChange={(value) =>
              handleQuestionFormChange(form.questionId, "questionText", value)
            }
          />
        </Row>
        <Row widths={"fill"}>
          <Input size="xlarge" label="Compliance" onChange={() => {}} />
          <Input size="xlarge" label="Non Compliance" />
        </Row>
      </Column>
      <Column>
        <Row>
          <Text type="h300">Sample Images for 'Yes, Accessible'</Text>
        </Row>
        <Row>
          <ImageUploader handleImageUpload={handleImageUpload} draggable />
          {form.examples.map((example) => (
            <SampleImageCard key={example.exampleId} src={example.imageURL} />
          ))}
        </Row>
      </Column>
      <Column>
        <Row>
          <Text type="h300">Sample Images for ‘Not Accessible’</Text>
        </Row>
        <Row>
          <ImageUploader handleImageUpload={handleImageUpload} draggable />
          <SampleImageCard src="" />
          <SampleImageCard src="" />
        </Row>
      </Column>
      <Button
        className="question-form-delete-btn"
        type="secondary"
        onClick={() => deleteForm(form.questionId)}
        size="large"
      >
        <Icon tokens={closeKnockoutTokens} />
      </Button>
    </Column>
  );
};

export default AddQuestionFormCard;
